export const POSITIONS = ['GK', 'DEF', 'MID', 'FWD'] as const;
export type Position = (typeof POSITIONS)[number];

export type PlayerStatus = 'Available' | 'Doubtful' | 'Injured' | 'Suspended';

/** A unique player identifier. Branded so a raw number can't be passed by mistake. */
export type PlayerId = number & { readonly __brand: 'PlayerId' };

export const toPlayerId = (n: number): PlayerId => n as PlayerId;

export interface Player {
  id: PlayerId;
  name: string;
  position: Position;
  club: string;
  /** Market price in millions. */
  price: number;
  /** Total fantasy points this season. */
  points: number;
  /** Rolling form rating, 0–10. */
  form: number;
  /** Percentage of managers who own this player. */
  selectedBy: number;
  status: PlayerStatus;
  gameweekPoints: number;
  goals: number;
  assists: number;
  cleanSheets: number;
  appearances: number;
  minutesPlayed: number;
}
